module.exports = __webpack_public_path__ + "static/assets/f6f0a50f33d1b507e65e8fb75441a224.png";